module.exports = __webpack_public_path__ + "static/media/blog01.fea810ed.png";